import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  login,
  clearError,
  confirmOtp,
  confirmNewPassword,
  resetAuthStep,
} from "@/store/slices/authSlice";
import type { RootState, AppDispatch } from "@/store";
import { LoginForm } from "@/components/login-form";
import { OtpForm } from "@/components/OtpForm";
import { NewPasswordForm } from "@/components/NewPasswordForm";

export function Login() {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const {
    isLoading,
    error,
    isAuthenticated,
    authStep,
    requiresNewPassword,
    email: storeEmail,
  } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(clearError());
    await dispatch(login({ email }));
  };

  const handleOtpSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(clearError());
    await dispatch(confirmOtp({ code }));
  };

  const handleNewPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(clearError());
    await dispatch(
      confirmNewPassword({ password: newPassword, confirmPassword })
    );
  };

  const handleBackToLogin = () => {
    dispatch(resetAuthStep());
    setNewPassword("");
    setConfirmPassword("");
    setCode("");
  };

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm">
        {authStep === "NEW_PASSWORD" || requiresNewPassword ? (
          <NewPasswordForm
            handleNewPassword={handleNewPassword}
            handleBackToLogin={handleBackToLogin}
            isLoading={isLoading}
            error={error}
            newPassword={newPassword}
            setNewPassword={setNewPassword}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
          />
        ) : authStep === "OTP" ? (
          <OtpForm
            handleOtpSubmit={handleOtpSubmit}
            handleBackToLogin={handleBackToLogin}
            isLoading={isLoading}
            error={error}
            setCode={setCode}
            code={code}
            email={storeEmail || email}
          />
        ) : (
          <LoginForm
            handleLogin={handleLogin}
            isLoading={isLoading}
            error={error}
            setEmail={setEmail}
            email={email}
          />
        )}
      </div>
    </div>
  );
}
